const FINDING_UPDATE_FALLBACK = 'Failed to save changes';

export class FindingSaveRejectedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FindingSaveRejectedError';
  }
}

export function findingUpdateErrorMessage(body: unknown): string {
  if (body === null || typeof body !== 'object') {
    return FINDING_UPDATE_FALLBACK;
  }

  const message = Reflect.get(body, 'message');

  if (typeof message === 'string' && message.trim().length > 0) {
    return message;
  }

  return FINDING_UPDATE_FALLBACK;
}
